export default __webpack_public_path__ + "static/media/17.d92c2431.PNG";